module.exports = __webpack_public_path__ + "static/media/indentplanner.9a91170d.b9213868.png";